export default {"src":"/_next/static/media/whoop-logo-dark.c863ef6c.svg","height":34,"width":206,"blurWidth":0,"blurHeight":0};